import React from 'react';
import fetch from 'common/services/fetch';
import wx from 'common/services/wx';
import utils from 'common/utils';
import store from 'common/services/storage';
import VerifyConfirmInfo from './verifyConfirmInfo';
import modal from 'components/mtModal/mtModal';
import toast from 'components/mtToast/mtToast';
import { withRouter } from 'react-router-dom';
import './saleConfirm.scss';

class SaleConfirmView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      grouponCode: '',
      num: 1,
    };
    this.handleNumberSelect = this.handleNumberSelect.bind(this);
    this.handleGrouponCode = this.handleGrouponCode.bind(this);
    this.logOut = this.logOut.bind(this);
    this.scanQR = this.scanQR.bind(this);
    document.title = '核销';
  }
  handleGrouponCode(e) {
    this.setState({
      grouponCode: e.target.value,
    });
  }
  scanQR() {
    wx.scanQRCode(true).then((res) => {
      this.setState({
        grouponCode: res,
      });
      this.confirmGroupon(true);
    }, () => {
      console.log('error');
    });
  }
  handleNumberSelect(num) {
    this.setState({
      num,
    });
  }
  showGrouponInfo(data) {
    const { unverifyNum, unverifyText, actTitle, groupTitle, verifyTime, verifyTip, payTime} = data;
    modal.popConfirm(<VerifyConfirmInfo total={unverifyNum} unverifyText={unverifyText}
      handleSelect={this.handleNumberSelect}
       actTitle={actTitle}
       groupTitle={groupTitle}
       verifyTime={verifyTime}
       verifyTip={verifyTip}
       payTime={payTime}
       groupData={data}
       />, null, null, null, () => {
      this.verify(this.state.num, true);
    });
  }
  confirmGroupon(fromScan) {
    const partnerId = store.get('LOGIN_UID');
    if (utils.isEmpty(this.state.grouponCode)) {
      toast.pop('请输入券码');
      return;
    }
    fetch.post(`/partner/bend/checkGroupon/${partnerId}/${this.state.grouponCode}/${fromScan ? 2 : 1}`, {}, { raw: true }).then((res) => {
      if (res.status) {
        const data = res.data;
        if (data.grouponType === 1) {
          modal.popConfirm(data.toast, null, null, null, () => {
            this.showGrouponInfo(data);
          });
        } else {
          this.showGrouponInfo(data);
        }
      } else {
        modal.pop(res.error);
      }
    });
  }
  /* eslint-disable */
  logOut() {
    store.remove('LOGIN_UID');
    store.remove('MT_TOKEN');
    location.href = '/userLogin';
  }
  verify(num, fromScan) {
    const partnerId = store.get('LOGIN_UID');
    const params = {
      partnerId,
      grouponCode: this.state.grouponCode,
      verifyType: fromScan ? 2 : 1,
      verifyNum: num,
      punchinType: 5,
    }
    fetch.post('/partner/bend/verify', params, { loading: true }).then((res) => {
      toast.pop(res.toast);
    });
  }
  blurHandler() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className='saleConfirmView'>
        <div className='logout' onClick={() => this.logOut()}>退出登录</div>
        <div className='grouponForm'>
          <input value={this.state.grouponCode} onChange={this.handleGrouponCode} placeholder='请输入麦淘券' onBlur={this.blurHandler}/>
          <img src={require('assets/images/icon-scan-green.png')} onClick={this.scanQR}/>
        </div>
        <div className='confirmButton' onClick={() => this.confirmGroupon()}>核销</div>
        <div className='confirmHistory' onClick={() => this.props.history.push('/confirmedRecord')}>
          <img src={require('assets/images/icon-history-green.png')}/>
          <span>核销记录</span>
        </div>
      </div>
    );
  }
}
export default withRouter(SaleConfirmView);
